webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIxLjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCAxMzkuNyAxMzkuNyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTM5LjcgMTM5Ljc7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojQzIxMzMzO30KPC9zdHlsZT4KPHRpdGxlPkJ1dHRvbl8rPC90aXRsZT4KPHBhdGggY2xhc3M9InN0MCIgZD0iTTY5LjgsMEMzMS4zLDAsMCwzMS4zLDAsNjkuOGMwLDM4LjUsMzEuMyw2OS45LDY5LjgsNjkuOWgwYzM4LjUtMC4xLDY5LjgtMzEuNSw2OS44LTY5LjkKCUMxMzkuNiwzMS4zLDEwOC4zLDAsNjkuOCwweiBNMTM0LjYsNjkuOGMwLDM1LjctMjkuMSw2NC44LTY0LjgsNjQuOEMzNC4xLDEzNC42LDUsMTA1LjUsNSw2OS44QzUsMzQuMSwzNC4xLDUsNjkuOCw1CglDMTA1LjUsNSwxMzQuNiwzNC4xLDEzNC42LDY5Ljh6Ii8+CjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik05NSw2Ny44Yy0wLjUtMC42LTEuMy0wLjktMi4xLTAuOUg3Mi43VjQ2LjhjMC0xLjYtMS4zLTIuOS0yLjktMi45Yy0xLjYsMC0yLjksMS4zLTIuOSwyLjl2MjAuMkg0Ni44CgljLTEuNiwwLTIuOSwxLjMtMi45LDIuOWMwLDEuNiwxLjMsMi45LDIuOSwyLjloMjAuMnYyMC4yYzAsMS42LDEuMywyLjksMi45LDIuOWMxLjYsMCwyLjktMS4zLDIuOS0yLjlWNzIuN2gyMC4yCgljMS42LDAsMi45LTEuMywyLjktMi44Qzk1LjgsNjkuMSw5NS41LDY4LjQsOTUsNjcuOHoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = localise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__i18n__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_index__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__(72);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: __WEBPACK_IMPORTED_MODULE_3__routes_index__["a" /* default */],
  linkActiveClass: 'active',
  linkExactActiveClass: 'exact-active',
  fallback: false
});

router.beforeEach(function (to, from, next) {
  if (to.meta.name === from.meta.name) {
    return next();
  }

  var delay = 0;
  if (__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.hasOverlays) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('hideOverlays');
    delay += 250;
  }

  setTimeout(function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["a" /* scrollToTop */])(next);
  }, delay);
});

router.afterEach(function (to, from) {
  if (!to.hash) {
    return;
  }

  var delay = 0;
  if (to.name !== from.name) {
    delay = 1000;
  }

  setTimeout(function () {
    var $target = document.querySelector(to.hash);

    var offset = window.innerHeight / 3;

    if ($target.clientHeight <= window.innerHeight - offset) {
      offset = (window.innerHeight - $target.clientHeight) / 2;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["b" /* scrollTo */])($target, -offset);
  }, delay);
});

/* harmony default export */ __webpack_exports__["a"] = (router);

function localise(from, locale) {
  var to = from.path.split('/');

  if (__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].fallbackLocale === locale) {
    to.splice(2, 1);
  } else if (__WEBPACK_IMPORTED_MODULE_2__i18n__["a" /* default */].fallbackLocale === from.meta.locale) {
    to.splice(2, 0, locale);
  } else {
    to[2] = locale;
  }

  return to.join('/');
}

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_LOCALE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ADD_LOCALE_MESSAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SHOW_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return HIDE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return OPEN_SIDE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return CLOSE_SIDE_MENU; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_RUYI_STOCK_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_RUYI_STOCK_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_RENOWN_STOCK_PRICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_RENOWN_STOCK_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SHOW_SITEMAP_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HIDE_SITEMAP_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SHOW_WECHAT_OVERLAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return HIDE_WECHAT_OVERLAY; });
var SET_LOCALE = 'SET_LOCALE';
var ADD_LOCALE_MESSAGES = 'ADD_LOCALE_MESSAGES';

var SHOW_HEADER = 'SHOW_HEADER';
var HIDE_HEADER = 'HIDE_HEADER';

var OPEN_SIDE_MENU = 'OPEN_SIDE_MENU';
var CLOSE_SIDE_MENU = 'CLOSE_SIDE_MENU';

var SET_RUYI_STOCK_PRICE = 'SET_RUYI_STOCK_PRICE';
var SET_RUYI_STOCK_CHANGE = 'SET_RUYI_STOCK_CHANGE';
var SET_RENOWN_STOCK_PRICE = 'SET_RENOWN_STOCK_PRICE';
var SET_RENOWN_STOCK_CHANGE = 'SET_RENOWN_STOCK_CHANGE';

var SHOW_SITEMAP_OVERLAY = 'SHOW_SITEMAP_OVERLAY';
var HIDE_SITEMAP_OVERLAY = 'HIDE_SITEMAP_OVERLAY';
var SHOW_WECHAT_OVERLAY = 'SHOW_WECHAT_OVERLAY';
var HIDE_WECHAT_OVERLAY = 'HIDE_WECHAT_OVERLAY';

/***/ }),
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_storage_helper__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_storage_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_storage_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__messages__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(96);









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

var locale = __WEBPACK_IMPORTED_MODULE_2_storage_helper___default.a.getItem('locale', false, 'cn');

var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: locale,
  messages: __WEBPACK_IMPORTED_MODULE_3__messages__["a" /* default */],
  fallbackLocale: 'cn'
});

__WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (!from.name) {
    return __WEBPACK_IMPORTED_MODULE_5__store__["a" /* default */].dispatch('setLocale', to.meta.locale).then(next);
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    matchedBreakpoint: function matchedBreakpoint() {
      return this.$mq.all[this.$mq.all.length - 1];
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  watch: {
    '$i18n.locale': function $i18nLocale() {
      this.$emit('updateHead');
    }
  }
});

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      inPageNavActive: null
    };
  },

  methods: {
    updateInPageNav: function updateInPageNav(target, direction) {
      if (direction === this.$scrollDirection().y) {
        this.inPageNavActive = target;
      }
    }
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = scrollTo;
/* harmony export (immutable) */ __webpack_exports__["a"] = scrollToTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = isMobileDevice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_velocity_animate__);


function scrollTo(element) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var callback = arguments[2];

  if (typeof offset !== 'number') {
    callback = offset;
    offset = 0;
  }

  __WEBPACK_IMPORTED_MODULE_0_velocity_animate___default()(element, 'scroll', {
    duration: 500,
    offset: offset,
    easing: 'ease-in-out',
    complete: callback
  });
}

function scrollToTop(callback) {
  if (window.scrollY === 0) {
    if (typeof callback === 'function') {
      callback();
    }

    return;
  }

  var $body = document.querySelector('body');
  scrollTo($body, callback);
}

function isMobileDevice() {
  return typeof window.orientation !== 'undefined';
}

/***/ }),
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(541)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(269),
  /* template */
  __webpack_require__(631),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */,
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins__ = __webpack_require__(260);






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* default */].Store({
  modules: __WEBPACK_IMPORTED_MODULE_2__modules__["a" /* default */],
  plugins: __WEBPACK_IMPORTED_MODULE_3__plugins__["a" /* default */],
  strict: debug
}));

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(633),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(527)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(264),
  /* template */
  __webpack_require__(617),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(538)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(265),
  /* template */
  __webpack_require__(628),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(533)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(266),
  /* template */
  __webpack_require__(623),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(532)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(267),
  /* template */
  __webpack_require__(622),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(529)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(268),
  /* template */
  __webpack_require__(619),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(530)
}
var Component = __webpack_require__(9)(
  /* script */
  null,
  /* template */
  __webpack_require__(620),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(280),
  /* template */
  __webpack_require__(629),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(35);


// Only run on client-side and only in production mode
if (true) {
  (function () {
    var hm = document.createElement('script');
    hm.src = 'https://hm.baidu.com/hm.js?' + "554f882cc943bd067175819f75e53e06";
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(hm, s);
  })();

  __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].afterEach(function (to, from) {
    window._hmt && window._hmt.push(['_trackPageview', to.fullPath]);
  });
}

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_clickaway__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('onClickaway', __WEBPACK_IMPORTED_MODULE_1_vue_clickaway__["directive"]);

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(35);


// Only run on client-side and only in production mode
if (true) {
  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    };
    i[r].l = 1 * new Date();
    a = s.createElement(o);
    m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

  window.ga('create', "UA-105258113-1", 'auto');

  __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].afterEach(function (to, from) {
    window.ga('set', 'page', to.fullPath);
    window.ga('send', 'pageview');
  });
}

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_head__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_head__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_head___default.a, {
  separator: ' - '
});

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_match_media__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_match_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_match_media__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_match_media___default.a);

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_nprogress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_nprogress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(35);




__WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.configure({
  speed: 300,
  showSpinner: false
});

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].beforeEach(function (to, from, next) {
  if (to.name !== from.name) {
    __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.start();
  }
  next();
});

__WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].afterEach(function (to, from) {
  __WEBPACK_IMPORTED_MODULE_0_nprogress___default.a.done();
});

/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_nprogress___default.a);

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_parallax_js__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_parallax_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_parallax_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_parallax_js___default.a);

__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].afterEach(function (to, from) {
  if (to.meta.name !== from.meta.name) {
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].app.$parallaxjs.items = [];
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_waypoint__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_waypoint___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_waypoint__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_waypoint___default.a);

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classlist_polyfill__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classlist_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classlist_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_closest__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_closest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_closest__);




/***/ }),
/* 218 */
/***/ (function(module, exports) {

;(function(window){
var hadGlobal = 'Modernizr' in window;
var oldGlobal = window.Modernizr;
/*! modernizr 3.5.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-videoautoplay-setclasses !*/
!function(A,e,o){function t(A,e){return typeof A===e}function n(){var A,e,o,n,a,l,i;for(var s in c)if(c.hasOwnProperty(s)){if(A=[],e=c[s],e.name&&(A.push(e.name.toLowerCase()),e.options&&e.options.aliases&&e.options.aliases.length))for(o=0;o<e.options.aliases.length;o++)A.push(e.options.aliases[o].toLowerCase());for(n=t(e.fn,"function")?e.fn():e.fn,a=0;a<A.length;a++)l=A[a],i=l.split("."),1===i.length?Modernizr[i[0]]=n:(!Modernizr[i[0]]||Modernizr[i[0]]instanceof Boolean||(Modernizr[i[0]]=new Boolean(Modernizr[i[0]])),Modernizr[i[0]][i[1]]=n),h.push((n?"":"no-")+i.join("-"))}}function a(A){var e=R.className,o=Modernizr._config.classPrefix||"";if(d&&(e=e.baseVal),Modernizr._config.enableJSClass){var t=new RegExp("(^|\\s)"+o+"no-js(\\s|$)");e=e.replace(t,"$1"+o+"js$2")}Modernizr._config.enableClasses&&(e+=" "+o+A.join(" "+o),d?R.className.baseVal=e:R.className=e)}function l(A,e){if("object"==typeof A)for(var o in A)r(A,o)&&l(o,A[o]);else{A=A.toLowerCase();var t=A.split("."),n=Modernizr[t[0]];if(2==t.length&&(n=n[t[1]]),"undefined"!=typeof n)return Modernizr;e="function"==typeof e?e():e,1==t.length?Modernizr[t[0]]=e:(!Modernizr[t[0]]||Modernizr[t[0]]instanceof Boolean||(Modernizr[t[0]]=new Boolean(Modernizr[t[0]])),Modernizr[t[0]][t[1]]=e),a([(e&&0!=e?"":"no-")+t.join("-")]),Modernizr._trigger(A,e)}return Modernizr}function i(){return"function"!=typeof e.createElement?e.createElement(arguments[0]):d?e.createElementNS.call(e,"http://www.w3.org/2000/svg",arguments[0]):e.createElement.apply(e,arguments)}var c=[],s={_version:"3.5.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(A,e){var o=this;setTimeout(function(){e(o[A])},0)},addTest:function(A,e,o){c.push({name:A,fn:e,options:o})},addAsyncTest:function(A){c.push({name:null,fn:A})}},Modernizr=function(){};Modernizr.prototype=s,Modernizr=new Modernizr;var r,h=[],R=e.documentElement,d="svg"===R.nodeName.toLowerCase();!function(){var A={}.hasOwnProperty;r=t(A,"undefined")||t(A.call,"undefined")?function(A,e){return e in A&&t(A.constructor.prototype[e],"undefined")}:function(e,o){return A.call(e,o)}}(),s._l={},s.on=function(A,e){this._l[A]||(this._l[A]=[]),this._l[A].push(e),Modernizr.hasOwnProperty(A)&&setTimeout(function(){Modernizr._trigger(A,Modernizr[A])},0)},s._trigger=function(A,e){if(this._l[A]){var o=this._l[A];setTimeout(function(){var A,t;for(A=0;A<o.length;A++)(t=o[A])(e)},0),delete this._l[A]}},Modernizr._q.push(function(){s.addTest=l}),Modernizr.addTest("video",function(){var A=i("video"),e=!1;try{e=!!A.canPlayType,e&&(e=new Boolean(e),e.ogg=A.canPlayType('video/ogg; codecs="theora"').replace(/^no$/,""),e.h264=A.canPlayType('video/mp4; codecs="avc1.42E01E"').replace(/^no$/,""),e.webm=A.canPlayType('video/webm; codecs="vp8, vorbis"').replace(/^no$/,""),e.vp9=A.canPlayType('video/webm; codecs="vp9"').replace(/^no$/,""),e.hls=A.canPlayType('application/x-mpegURL; codecs="avc1.42E01E"').replace(/^no$/,""))}catch(o){}return e}),Modernizr.addAsyncTest(function(){function A(i){n++,clearTimeout(e);var c=i&&"playing"===i.type||0!==a.currentTime;return!c&&t>n?void(e=setTimeout(A,o)):(a.removeEventListener("playing",A,!1),l("videoautoplay",c),void(a.parentNode&&a.parentNode.removeChild(a)))}var e,o=200,t=5,n=0,a=i("video"),c=a.style;if(!(Modernizr.video&&"autoplay"in a))return void l("videoautoplay",!1);c.position="absolute",c.height=0,c.width=0;try{if(Modernizr.video.ogg)a.src="data:video/ogg;base64,T2dnUwACAAAAAAAAAABmnCATAAAAAHDEixYBKoB0aGVvcmEDAgEAAQABAAAQAAAQAAAAAAAFAAAAAQAAAAAAAAAAAGIAYE9nZ1MAAAAAAAAAAAAAZpwgEwEAAAACrA7TDlj///////////////+QgXRoZW9yYSsAAABYaXBoLk9yZyBsaWJ0aGVvcmEgMS4xIDIwMDkwODIyIChUaHVzbmVsZGEpAQAAABoAAABFTkNPREVSPWZmbXBlZzJ0aGVvcmEtMC4yOYJ0aGVvcmG+zSj3uc1rGLWpSUoQc5zmMYxSlKQhCDGMYhCEIQhAAAAAAAAAAAAAEW2uU2eSyPxWEvx4OVts5ir1aKtUKBMpJFoQ/nk5m41mUwl4slUpk4kkghkIfDwdjgajQYC8VioUCQRiIQh8PBwMhgLBQIg4FRba5TZ5LI/FYS/Hg5W2zmKvVoq1QoEykkWhD+eTmbjWZTCXiyVSmTiSSCGQh8PB2OBqNBgLxWKhQJBGIhCHw8HAyGAsFAiDgUCw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDw8PDAwPEhQUFQ0NDhESFRUUDg4PEhQVFRUOEBETFBUVFRARFBUVFRUVEhMUFRUVFRUUFRUVFRUVFRUVFRUVFRUVEAwLEBQZGxwNDQ4SFRwcGw4NEBQZHBwcDhATFhsdHRwRExkcHB4eHRQYGxwdHh4dGxwdHR4eHh4dHR0dHh4eHRALChAYKDM9DAwOExo6PDcODRAYKDlFOA4RFh0zV1A+EhYlOkRtZ00YIzdAUWhxXDFATldneXhlSFxfYnBkZ2MTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTExMTEhIVGRoaGhoSFBYaGhoaGhUWGRoaGhoaGRoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhESFh8kJCQkEhQYIiQkJCQWGCEkJCQkJB8iJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQkJCQREhgvY2NjYxIVGkJjY2NjGBo4Y2NjY2MvQmNjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRUVFRISEhUXGBkbEhIVFxgZGxwSFRcYGRscHRUXGBkbHB0dFxgZGxwdHR0YGRscHR0dHhkbHB0dHR4eGxwdHR0eHh4REREUFxocIBERFBcaHCAiERQXGhwgIiUUFxocICIlJRcaHCAiJSUlGhwgIiUlJSkcICIlJSUpKiAiJSUlKSoqEBAQFBgcICgQEBQYHCAoMBAUGBwgKDBAFBgcICgwQEAYHCAoMEBAQBwgKDBAQEBgICgwQEBAYIAoMEBAQGCAgAfF5cdH1e3Ow/L66wGmYnfIUbwdUTe3LMRbqON8B+5RJEvcGxkvrVUjTMrsXYhAnIwe0dTJfOYbWrDYyqUrz7dw/JO4hpmV2LsQQvkUeGq1BsZLx+cu5iV0e0eScJ91VIQYrmqfdVSK7GgjOU0oPaPOu5IcDK1mNvnD+K8LwS87f8Jx2mHtHnUkTGAurWZlNQa74ZLSFH9oF6FPGxzLsjQO5Qe0edcpttd7BXBSqMCL4k/4tFrHIPuEQ7m1/uIWkbDMWVoDdOSuRQ9286kvVUlQjzOE6VrNguN4oRXYGkgcnih7t13/9kxvLYKQezwLTrO44sVmMPgMqORo1E0sm1/9SludkcWHwfJwTSybR4LeAz6ugWVgRaY8mV/9SluQmtHrzsBtRF/wPY+X0JuYTs+ltgrXAmlk10xQHmTu9VSIAk1+vcvU4ml2oNzrNhEtQ3CysNP8UeR35wqpKUBdGdZMSjX4WVi8nJpdpHnbhzEIdx7mwf6W1FKAiucMXrWUWVjyRf23chNtR9mIzDoT/6ZLYailAjhFlZuvPtSeZ+2oREubDoWmT3TguY+JHPdRVSLKxfKH3vgNqJ/9emeEYikGXDFNzaLjvTeGAL61mogOoeG3y6oU4rW55ydoj0lUTSR/mmRhPmF86uwIfzp3FtiufQCmppaHDlGE0r2iTzXIw3zBq5hvaTldjG4CPb9wdxAme0SyedVKczJ9AtYbgPOzYKJvZZImsN7ecrxWZg5dR6ZLj/j4qpWsIA+vYwE+Tca9ounMIsrXMB4Stiib2SPQtZv+FVIpfEbzv8ncZoLBXc3YBqTG1HsskTTotZOYTG+oVUjLk6zhP8bg4RhMUNtfZdO7FdpBuXzhJ5Fh8IKlJG7wtD9ik8rWOJxy6iQ3NwzBpQ219mlyv+FLicYs2iJGSE0u2txzed++D61ZWCiHD/cZdQVCqkO2gJpdpNaObhnDfAPrT89RxdWFZ5hO3MseBSIlANppdZNIV/Rwe5eLTDvkfWKzFnH+QJ7m9QWV1KdwnuIwTNtZdJMoXBf74OhRnh2t+OTGL+AVUnIkyYY+QG7g9itHXyF3OIygG2s2kud679ZWKqSFa9n3IHD6MeLv1lZ0XyduRhiDRtrNnKoyiFVLcBm0ba5Yy3fQkDh4XsFE34isVpOzpa9nR8iCpS4HoxG2rJpnRhf3YboVa1PcRouh5LIJv/uQcPNd095ickTaiGBnWLKVWRc0OnYTSyex/n2FofEPnDG8y3PztHrzOLK1xo6RAml2k9owKajOC0Wr4D5x+3nA0UEhK2m198wuBHF3zlWWVKWLN1CHzLClUfuoYBcx4b1llpeBKmbayaR58njtE9onD66lUcsg0Spm2snsb+8HaJRn4dYcLbCuBuYwziB8/5U1C1DOOz2gZjSZtrLJk6vrLF3hwY4Io9xuT/ruUFRSBkNtUzTOWhjh26irLEPx4jPZL3Fo3QrReoGTTM21xYTT9oFdhTUIvjqTkfkvt0bzgVUjq/hOYY8j60IaO/0AzRBtqkTS6R5ellZd5uKdzzhb8BFlDdAcrwkE0rbXTOPB+7Y0FlZO96qFL4Ykg21StJs8qIW7h16H5hGiv8V2Cflau7QVDepTAHa6Lgt6feiEvJDM21StJsmOH/hynURrKxvUpQ8BH0JF7BiyG2qZpnL/7AOU66gt+reLEXY8pVOCQvSsBtqZTNM8bk9ohRcwD18o/WVkbvrceVKRb9I59IEKysjBeTMmmbA21xu/6iHadLRxuIzkLpi8wZYmmbbWi32RVAUjruxWlJ//iFxE38FI9hNKOoCdhwf5fDe4xZ81lgREhK2m1j78vW1CqkuMu/AjBNK210kzRUX/B+69cMMUG5bYrIeZxVSEZISmkzbXOi9yxwIfPgdsov7R71xuJ7rFcACjG/9PzApqFq7wEgzNJm2suWESPuwrQvejj7cbnQxMkxpm21lUYJL0fKmogPPqywn7e3FvB/FCNxPJ85iVUkCE9/tLKx31G4CgNtWTTPFhMvlu8G4/TrgaZttTChljfNJGgOT2X6EqpETy2tYd9cCBI4lIXJ1/3uVUllZEJz4baqGF64yxaZ+zPLYwde8Uqn1oKANtUrSaTOPHkhvuQP3bBlEJ/LFe4pqQOHUI8T8q7AXx3fLVBgSCVpMba55YxN3rv8U1Dv51bAPSOLlZWebkL8vSMGI21lJmmeVxPRwFlZF1CpqCN8uLwymaZyjbXHCRytogPN3o/n74CNykfT+qqRv5AQlHcRxYrC5KvGmbbUwmZY/29BvF6C1/93x4WVglXDLFpmbapmF89HKTogRwqqSlGbu+oiAkcWFbklC6Zhf+NtTLFpn8oWz+HsNRVSgIxZWON+yVyJlE5tq/+GWLTMutYX9ekTySEQPLVNQQ3OfycwJBM0zNtZcse7CvcKI0V/zh16Dr9OSA21MpmmcrHC+6pTAPHPwoit3LHHqs7jhFNRD6W8+EBGoSEoaZttTCZljfduH/fFisn+dRBGAZYtMzbVMwvul/T/crK1NQh8gN0SRRa9cOux6clC0/mDLFpmbarmF8/e6CopeOLCNW6S/IUUg3jJIYiAcDoMcGeRbOvuTPjXR/tyo79LK3kqqkbxkkMRAOB0GODPItnX3Jnxro/25Ud+llbyVVSN4ySGIgHA6DHBnkWzr7kz410f7cqO/Syt5KqpFVJwn6gBEvBM0zNtZcpGOEPiysW8vvRd2R0f7gtjhqUvXL+gWVwHm4XJDBiMpmmZtrLfPwd/IugP5+fKVSysH1EXreFAcEhelGmbbUmZY4Xdo1vQWVnK19P4RuEnbf0gQnR+lDCZlivNM22t1ESmopPIgfT0duOfQrsjgG4tPxli0zJmF5trdL1JDUIUT1ZXSqQDeR4B8mX3TrRro/2McGeUvLtwo6jIEKMkCUXWsLyZROd9P/rFYNtXPBli0z398iVUlVKAjFlY437JXImUTm2r/4ZYtMy61hf16RPJIU9nZ1MABAwAAAAAAAAAZpwgEwIAAABhp658BScAAAAAAADnUFBQXIDGXLhwtttNHDhw5OcpQRMETBEwRPduylKVB0HRdF0A";else{if(!Modernizr.video.h264)return void l("videoautoplay",!1);a.src="data:video/mp4;base64,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"}}catch(s){return void l("videoautoplay",!1)}a.setAttribute("autoplay",""),a.style.cssText="display:none",R.appendChild(a),setTimeout(function(){a.addEventListener("playing",A,!1),e=setTimeout(A,o)},0)}),n(),a(h),delete s.addTest,delete s.addAsyncTest;for(var E=0;E<Modernizr._q.length;E++)Modernizr._q[E]();A.Modernizr=Modernizr}(window,document);
module.exports = window.Modernizr;
if (hadGlobal) { window.Modernizr = oldGlobal; }
else { delete window.Modernizr; }
})(window);

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(534)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(262),
  /* template */
  __webpack_require__(624),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_set__);


var messages = {};

var files = __webpack_require__(643);
files.keys().forEach(function (key) {
  var path = key.replace(/(\.\/|\.json)/g, '').replace(/(\/)/g, '.');

  __WEBPACK_IMPORTED_MODULE_0_lodash_set___default()(messages, path, files(key));
});

/* harmony default export */ __webpack_exports__["a"] = (messages);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modernizr__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_modernizr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_modernizr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_router_sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__plugins_baidu_tongji__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_clickaway__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_head__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_google_analytics__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__plugins_match_media__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__plugins_parallax__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__plugins_nprogress__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__plugins_waypoint__ = __webpack_require__(216);



var boot = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('setLocale', __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].locale);

          case 2:
            _context.next = 4;
            return __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('loadLocaleMessages', __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].fallbackLocale);

          case 4:

            /* eslint-disable no-new */
            new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
              el: '#app',
              i18n: __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */],
              router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
              store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
              // template: '<App/>',
              components: { App: __WEBPACK_IMPORTED_MODULE_6__App___default.a },
              mq: {
                xs: '(min-width: 0px)',
                md: '(min-width: 768px)',
                xl: '(min-width: 1280px)'
              }
            });

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function boot() {
    return _ref.apply(this, arguments);
  };
}();

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




















__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex_router_sync__["sync"])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;

boot();

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Content__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Content__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/content/*',
  name: 'cn.content',
  meta: {
    name: 'content',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Content___default.a
});

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Fashion__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/fashion',
  name: 'cn.fashion',
  meta: {
    name: 'fashion',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion___default.a
});

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Home__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home',
  name: 'cn.home',
  meta: {
    name: 'home',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Home___default.a
});

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/ruyi',
  name: 'cn.ruyi',
  meta: {
    name: 'ruyi',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi___default.a
});

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/sustainability',
  name: 'cn.sustainability',
  meta: {
    name: 'sustainability',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability___default.a
});

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Technology__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Technology___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Technology__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/technology',
  name: 'cn.technology',
  meta: {
    name: 'technology',
    locale: 'cn'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Technology___default.a
});

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Content__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Content__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/content/en/*',
  name: 'en.content',
  meta: {
    name: 'content',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Content___default.a
});

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Fashion__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/en/fashion',
  name: 'en.fashion',
  meta: {
    name: 'fashion',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Fashion___default.a
});

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Home__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Home__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/en',
  name: 'en.home',
  meta: {
    name: 'home',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Home___default.a
});

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/en/ruyi',
  name: 'en.ruyi',
  meta: {
    name: 'ruyi',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Ruyi___default.a
});

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/en/sustainability',
  name: 'en.sustainability',
  meta: {
    name: 'sustainability',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Sustainability___default.a
});

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Technology__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_views_Technology___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_views_Technology__);


/* harmony default export */ __webpack_exports__["a"] = ({
  path: '/home/en/technology',
  name: 'en.technology',
  meta: {
    name: 'technology',
    locale: 'en'
  },
  component: __WEBPACK_IMPORTED_MODULE_0__components_views_Technology___default.a
});

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Landing__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layouts_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layouts_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cn_home__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cn_ruyi__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cn_technology__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cn_fashion__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cn_sustainability__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cn_content__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__en_home__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__en_ruyi__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__en_technology__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__en_fashion__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__en_sustainability__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__en_content__ = __webpack_require__(246);


















/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_1__components_layouts_Landing___default.a,
  redirect: function redirect() {
    return {
      name: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].locale + '.home'
    };
  },

  children: [
  // en
  __WEBPACK_IMPORTED_MODULE_8__en_home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__en_ruyi__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__en_technology__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__en_fashion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__en_sustainability__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__en_content__["a" /* default */],
  // default
  __WEBPACK_IMPORTED_MODULE_2__cn_home__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__cn_ruyi__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__cn_technology__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__cn_fashion__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cn_sustainability__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__cn_content__["a" /* default */]]
}, {
  path: '*',
  redirect: function redirect() {
    return {
      name: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */].locale + '.home'
    };
  }
}]);

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__i18n__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__ = __webpack_require__(53);




var _mutations;







/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    locale: null,
    availableMessages: []
  },
  getters: {
    isLocalMessagesLoaded: function isLocalMessagesLoaded(state) {
      return function (locale) {
        return state.availableMessages.indexOf(locale) !== -1;
      };
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* SET_LOCALE */], function (state, locale) {
    state.locale = locale;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["n" /* ADD_LOCALE_MESSAGES */], function (state, locale) {
    state.availableMessages.push(locale);
  }), _mutations),
  actions: {
    setLocale: function setLocale(_ref, locale) {
      var _this = this;

      var dispatch = _ref.dispatch,
          commit = _ref.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch('loadLocaleMessages', locale);

              case 2:

                commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["a" /* SET_LOCALE */], locale);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__helpers_utils__["a" /* scrollToTop */])();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    loadLocaleMessages: function loadLocaleMessages(_ref2, locale) {
      var _this2 = this;

      var getters = _ref2.getters,
          commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (getters.isLocalMessagesLoaded(locale)) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get("/content/wp-json/ruyi/v2/megahome" + '/' + locale);

              case 3:
                response = _context2.sent;


                // i18n.setLocaleMessage(locale, response.data)
                __WEBPACK_IMPORTED_MODULE_4__i18n__["a" /* default */].mergeLocaleMessage(locale, response.data);

                commit(__WEBPACK_IMPORTED_MODULE_6__store_mutation_types__["n" /* ADD_LOCALE_MESSAGES */], locale);

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__i18n__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landing_header__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__overlays__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__side_menu__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stocks__ = __webpack_require__(259);







/* harmony default export */ __webpack_exports__["a"] = ({
  i18n: __WEBPACK_IMPORTED_MODULE_0__i18n__["a" /* default */],
  landingHeader: __WEBPACK_IMPORTED_MODULE_1__landing_header__["a" /* default */],
  overlays: __WEBPACK_IMPORTED_MODULE_2__overlays__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  sideMenu: __WEBPACK_IMPORTED_MODULE_4__side_menu__["a" /* default */],
  stocks: __WEBPACK_IMPORTED_MODULE_5__stocks__["a" /* default */]
});

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(53);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isHidden: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["l" /* SHOW_HEADER */], function (state) {
    state.isHidden = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* HIDE_HEADER */], function (state) {
    state.isHidden = true;
  }), _mutations),
  actions: {
    showHeader: function showHeader(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (state.isHidden) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["l" /* SHOW_HEADER */]);
      }
    },
    hideHeader: function hideHeader(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      if (!state.isHidden) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["m" /* HIDE_HEADER */]);
      }
    }
  }
});

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(53);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    sitemap: {
      isShown: false
    },
    wechat: {
      isShown: false
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["h" /* SHOW_SITEMAP_OVERLAY */], function (state) {
    state.sitemap.isShown = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["i" /* HIDE_SITEMAP_OVERLAY */], function (state) {
    state.sitemap.isShown = false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["j" /* SHOW_WECHAT_OVERLAY */], function (state) {
    state.wechat.isShown = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["k" /* HIDE_WECHAT_OVERLAY */], function (state) {
    state.wechat.isShown = false;
  }), _mutations),
  getters: {
    hasOverlays: function hasOverlays(state) {
      return state.sitemap.isShown || state.wechat.isShown;
    }
  },
  actions: {
    hideOverlays: function hideOverlays(_ref) {
      var dispatch = _ref.dispatch;

      dispatch('hideSitemapOverlay');
      dispatch('hideWechatOverlay');
    },
    showSitemapOverlay: function showSitemapOverlay(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CLOSE_SIDE_MENU */]);
      commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["l" /* SHOW_HEADER */]);

      if (!state.sitemap.isShown) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["h" /* SHOW_SITEMAP_OVERLAY */]);
      }
    },
    hideSitemapOverlay: function hideSitemapOverlay(_ref3) {
      var state = _ref3.state,
          commit = _ref3.commit;

      if (state.sitemap.isShown) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["i" /* HIDE_SITEMAP_OVERLAY */]);
      }
    },
    toggleSitemapOverlay: function toggleSitemapOverlay(_ref4) {
      var state = _ref4.state,
          dispatch = _ref4.dispatch;

      dispatch(!state.sitemap.isShown ? 'showSitemapOverlay' : 'hideSitemapOverlay');
    },
    showWechatOverlay: function showWechatOverlay(_ref5) {
      var state = _ref5.state,
          commit = _ref5.commit;

      commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CLOSE_SIDE_MENU */]);
      commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["l" /* SHOW_HEADER */]);

      if (!state.wechat.isShown) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["j" /* SHOW_WECHAT_OVERLAY */]);
      }
    },
    hideWechatOverlay: function hideWechatOverlay(_ref6) {
      var state = _ref6.state,
          commit = _ref6.commit;

      if (state.wechat.isShown) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["k" /* HIDE_WECHAT_OVERLAY */]);
      }
    },
    toggleWechatOverlay: function toggleWechatOverlay(_ref7) {
      var state = _ref7.state,
          dispatch = _ref7.dispatch;

      dispatch(!state.sitemap.isShown ? 'showWechatOverlay' : 'hideWechatOverlay');
    }
  }
});

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getters: {
    isHome: function isHome(state, getters, rootState) {
      return rootState.route.name === rootState.i18n.locale + ".home";
    },
    isContent: function isContent(state, getters, rootState) {
      return rootState.route.name === rootState.i18n.locale + ".content";
    }
  }
});

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__ = __webpack_require__(53);


var _mutations;



/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    isOpen: false
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["f" /* OPEN_SIDE_MENU */], function (state) {
    state.isOpen = true;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CLOSE_SIDE_MENU */], function (state) {
    state.isOpen = false;
  }), _mutations),
  actions: {
    openSideMenu: function openSideMenu(_ref) {
      var state = _ref.state,
          commit = _ref.commit;

      if (!state.isOpen) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["f" /* OPEN_SIDE_MENU */]);
      }
    },
    closeSideMenu: function closeSideMenu(_ref2) {
      var state = _ref2.state,
          commit = _ref2.commit;

      if (state.isOpen) {
        commit(__WEBPACK_IMPORTED_MODULE_1__store_mutation_types__["g" /* CLOSE_SIDE_MENU */]);
      }
    },
    toggleSideMenu: function toggleSideMenu(_ref3) {
      var state = _ref3.state,
          dispatch = _ref3.dispatch;

      if (state.isOpen) {
        dispatch('closeSideMenu');
      } else {
        dispatch('openSideMenu');
      }
    }
  }
});

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__ = __webpack_require__(53);




var _mutations;





var ruyiStockApi = "https://api.apifier.com/v1/i3ghZo5vWPCueZLYJ/crawlers/j8Aekrtzibyrn6HHm/lastExec/results?token=AF4rEFyvcCmmz2ZS5byhZ5SaK&status=SUCCEEDED&format=json&simplified=1";
var renownStockApi = "https://api.apifier.com/v1/i3ghZo5vWPCueZLYJ/crawlers/atFHB3yvpAKcALPtW/lastExec/results?token=AF4rEFyvcCmmz2ZS5byhZ5SaK&status=SUCCEEDED&format=json&simplified=1";

/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    ruyi: {
      price: 0.00,
      change: 0.00
    },
    renown: {
      price: 0.00,
      change: 0.00
    }
  },
  mutations: (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["b" /* SET_RUYI_STOCK_PRICE */], function (state, price) {
    state.ruyi.price = price;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["c" /* SET_RUYI_STOCK_CHANGE */], function (state, change) {
    state.ruyi.change = change;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["d" /* SET_RENOWN_STOCK_PRICE */], function (state, price) {
    state.renown.price = price;
  }), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* SET_RENOWN_STOCK_CHANGE */], function (state, change) {
    state.renown.change = change;
  }), _mutations),
  actions: {
    updateStocks: function updateStocks(_ref) {
      var dispatch = _ref.dispatch;

      dispatch('updateRuyiStock');
      dispatch('updateRenownStock');
    },
    updateRuyiStock: function updateRuyiStock(_ref2) {
      var _this = this;

      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref3, data, price, change;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(ruyiStockApi);

              case 2:
                _ref3 = _context.sent;
                data = _ref3.data;
                price = parseFloat(data[0].stockPrice).toFixed(2);
                change = data[0].changePercent.match(/(.*)%/)[1];

                if (!change) {
                  change = '+0';
                }

                commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["b" /* SET_RUYI_STOCK_PRICE */], price);
                commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["c" /* SET_RUYI_STOCK_CHANGE */], change);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    updateRenownStock: function updateRenownStock(_ref4) {
      var _this2 = this;

      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var _ref5, data, price, change;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get(renownStockApi);

              case 2:
                _ref5 = _context2.sent;
                data = _ref5.data;
                price = parseFloat(data[0].stockPrice).toFixed(2);
                change = data[0].change.match(/（(.*)%）/)[1];

                if (!change) {
                  change = '+0';
                }

                commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["d" /* SET_RENOWN_STOCK_PRICE */], price);
                commit(__WEBPACK_IMPORTED_MODULE_4__store_mutation_types__["e" /* SET_RENOWN_STOCK_CHANGE */], change);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
});

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_watcher__ = __webpack_require__(261);


/* harmony default export */ __webpack_exports__["a"] = ([__WEBPACK_IMPORTED_MODULE_0__locale_watcher__["a" /* default */]]);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_storage_helper__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_storage_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_storage_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18n__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__ = __webpack_require__(53);






/* harmony default export */ __webpack_exports__["a"] = (function (store) {
  store.subscribe(function (mutation, state) {
    if (mutation.type === __WEBPACK_IMPORTED_MODULE_3__store_mutation_types__["a" /* SET_LOCALE */]) {
      __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale = state.i18n.locale;

      replaceRoute(__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale);
      updateHtmlLangAttribute(__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale);
      storeUserPreferenceLocale(__WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale);
    }
  });
});

function replaceRoute(locale) {
  var from = __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].currentRoute;
  if (!from.name) {
    return;
  }

  if (from.meta.locale === locale) {
    return;
  }

  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router__["b" /* localise */])(from, locale));
}

function updateHtmlLangAttribute(locale) {
  document.getElementsByTagName('html')[0].setAttribute('lang', __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale);
}

function storeUserPreferenceLocale(locale) {
  __WEBPACK_IMPORTED_MODULE_0_storage_helper___default.a.setItem('locale', __WEBPACK_IMPORTED_MODULE_1__i18n__["a" /* default */].locale);
}

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['updateStocks'])),
  created: function created() {
    this.updateStocks();
  }
});

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_LandingFooter__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_widgets_LandingFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_widgets_LandingFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_LandingHeader__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_widgets_LandingHeader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_widgets_LandingHeader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_SideMenu__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_widgets_SideMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_widgets_SideMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Overlays_SitemapOverlay__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_widgets_Overlays_SitemapOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_widgets_Overlays_SitemapOverlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Overlays_WechatOverlay__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_widgets_Overlays_WechatOverlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_widgets_Overlays_WechatOverlay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      transition: 'view-slide'
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isHeaderHidden: function isHeaderHidden(state) {
      return state.landingHeader.isHidden;
    },
    isSideMenuOpen: function isSideMenuOpen(state) {
      return state.sideMenu.isOpen;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isHome', 'hasOverlays'])),
  components: {
    LandingFooter: __WEBPACK_IMPORTED_MODULE_2__components_widgets_LandingFooter___default.a,
    LandingHeader: __WEBPACK_IMPORTED_MODULE_3__components_widgets_LandingHeader___default.a,
    SideMenu: __WEBPACK_IMPORTED_MODULE_4__components_widgets_SideMenu___default.a,
    SitemapOverlay: __WEBPACK_IMPORTED_MODULE_5__components_widgets_Overlays_SitemapOverlay___default.a,
    WechatOverlay: __WEBPACK_IMPORTED_MODULE_6__components_widgets_Overlays_WechatOverlay___default.a
  }
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    styles: function styles() {
      return {
        coverBg: {
          backgroundImage: 'url(' + this.assets.cover[this.matchedBreakpoint] + ')'
        }
      };
    },
    assets: function assets() {
      return {
        cover: {
          xs: this.$t('pages.fashion.cover.xs'),
          md: this.$t('pages.fashion.cover.md'),
          xl: this.$t('pages.fashion.cover.xl')
        },
        image01: {
          xs: this.$t('pages.fashion.image-block-01.xs'),
          md: this.$t('pages.fashion.image-block-01.md'),
          xl: this.$t('pages.fashion.image-block-01.xl')
        },
        image02: {
          xs: this.$t('pages.fashion.image-block-02.xs'),
          md: this.$t('pages.fashion.image-block-02.md'),
          xl: this.$t('pages.fashion.image-block-02.xl')
        },
        image03: {
          xs: this.$t('pages.fashion.image-block-03.xs'),
          md: this.$t('pages.fashion.image-block-03.md'),
          xl: this.$t('pages.fashion.image-block-03.xl')
        },
        image04: {
          xs: this.$t('pages.fashion.image-block-04.xs'),
          md: this.$t('pages.fashion.image-block-04.md'),
          xl: this.$t('pages.fashion.image-block-04.xl')
        },
        image05: {
          md: this.$t('pages.fashion.image-block-05.md'),
          xl: this.$t('pages.fashion.image-block-05.xl')
        }
      };
    },
    inPageLinks: function inPageLinks() {
      return [{
        title: this.$t('pages.fashion.text-block-01.title'),
        hash: '#ruyi-brand-network'
      }, {
        title: 'SMCP',
        hash: '#smcp'
      }, {
        title: 'RENOWN',
        hash: '#renown'
      }];
    }
  },
  head: {
    title: function title() {
      return {
        inner: this.$t('pages.fashion.title'),
        complement: this.$t('common.ruyi-group')
      };
    }
  },
  components: {
    InPageNav: __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__["a" /* default */]]
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__ = __webpack_require__(63);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    assets: function assets() {
      return {
        transparent: __webpack_require__(602),
        cover: {
          ruyi: {
            xs: this.$t('pages.ruyi.cover.xs'),
            md: this.$t('pages.ruyi.cover.md'),
            xl: this.$t('pages.ruyi.cover.xl')
          },
          technology: {
            xs: this.$t('pages.technology.cover.xs'),
            md: this.$t('pages.technology.cover.md'),
            xl: this.$t('pages.technology.cover.xl')
          },
          fashion: {
            xs: this.$t('pages.fashion.cover.xs'),
            md: this.$t('pages.fashion.cover.md'),
            xl: this.$t('pages.fashion.cover.xl')
          },
          sustainability: {
            xs: this.$t('pages.sustainability.cover.xs'),
            md: this.$t('pages.sustainability.cover.md'),
            xl: this.$t('pages.sustainability.cover.xl')
          }
        }
      };
    },
    styles: function styles() {
      return {
        ruyi: {
          coverBg: {
            backgroundImage: 'url(' + this.assets.cover.ruyi[this.matchedBreakpoint] + ')'
          }
        },
        technology: {
          coverBg: {
            backgroundImage: 'url(' + this.assets.cover.technology[this.matchedBreakpoint] + ')'
          }
        },
        fashion: {
          coverBg: {
            backgroundImage: 'url(' + this.assets.cover.fashion[this.matchedBreakpoint] + ')'
          }
        },
        sustainability: {
          coverBg: {
            backgroundImage: 'url(' + this.assets.cover.sustainability[this.matchedBreakpoint] + ')'
          }
        }
      };
    }
  },
  methods: {
    isMobileDevice: __WEBPACK_IMPORTED_MODULE_0__helpers_utils__["c" /* isMobileDevice */]
  },
  head: {
    title: function title() {
      return {
        inner: this.$t('pages.home.title'),
        complement: this.$t('common.ruyi-group')
      };
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__["a" /* default */]]
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    styles: function styles() {
      return {
        coverBg: {
          backgroundImage: 'url(' + this.assets.cover[this.matchedBreakpoint] + ')'
        }
      };
    },
    assets: function assets() {
      return {
        cover: {
          xs: this.$t('pages.ruyi.cover.xs'),
          md: this.$t('pages.ruyi.cover.md'),
          xl: this.$t('pages.ruyi.cover.xl')
        },
        image01: {
          xs: this.$t('pages.ruyi.image-block-01.xs'),
          md: this.$t('pages.ruyi.image-block-01.md'),
          xl: this.$t('pages.ruyi.image-block-01.xl')
        },
        image02: {
          xs: this.$t('pages.ruyi.image-block-02.xs'),
          md: this.$t('pages.ruyi.image-block-02.md'),
          xl: this.$t('pages.ruyi.image-block-02.xl')
        },
        image03: {
          xs: this.$t('pages.ruyi.image-block-03.xs'),
          md: this.$t('pages.ruyi.image-block-03.md'),
          xl: this.$t('pages.ruyi.image-block-03.xl')
        },
        image04: {
          xs: this.$t('pages.ruyi.image-block-04.xs'),
          md: this.$t('pages.ruyi.image-block-04.md'),
          xl: this.$t('pages.ruyi.image-block-04.xl')
        }
      };
    },
    inPageLinks: function inPageLinks() {
      return [{
        title: this.$t('pages.ruyi.text-block-01.title'),
        hash: '#company-value'
      }, {
        title: this.$t('pages.ruyi.text-block-02.title'),
        hash: '#talents'
      }, {
        title: this.$t('pages.ruyi.text-block-03.title'),
        hash: '#social-responsibility'
      }];
    }
  },
  head: {
    title: function title() {
      return {
        inner: this.$t('pages.ruyi.title'),
        complement: this.$t('common.ruyi-group')
      };
    }
  },
  components: {
    InPageNav: __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__["a" /* default */]]
});

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    styles: function styles() {
      return {
        coverBg: {
          backgroundImage: 'url(' + this.assets.cover[this.matchedBreakpoint] + ')'
        }
      };
    },
    assets: function assets() {
      return {
        cover: {
          xs: this.$t('pages.sustainability.cover.xs'),
          md: this.$t('pages.sustainability.cover.md'),
          xl: this.$t('pages.sustainability.cover.xl')
        },
        image01: {
          xs: this.$t('pages.sustainability.image-block-01.xs'),
          md: this.$t('pages.sustainability.image-block-01.md'),
          xl: this.$t('pages.sustainability.image-block-01.xl')
        },
        image02: {
          xs: this.$t('pages.sustainability.image-block-02.xs'),
          md: this.$t('pages.sustainability.image-block-02.md'),
          xl: this.$t('pages.sustainability.image-block-02.xl')
        },
        image03: {
          xs: this.$t('pages.sustainability.image-block-03.xs'),
          md: this.$t('pages.sustainability.image-block-03.md'),
          xl: this.$t('pages.sustainability.image-block-03.xl')
        },
        image04: {
          xs: this.$t('pages.sustainability.image-block-04.xs'),
          md: this.$t('pages.sustainability.image-block-04.md'),
          xl: this.$t('pages.sustainability.image-block-04.xl')
        },
        image05: {
          xs: this.$t('pages.sustainability.image-block-05.xs'),
          md: this.$t('pages.sustainability.image-block-05.md'),
          xl: this.$t('pages.sustainability.image-block-05.xl')
        }
      };
    },
    inPageLinks: function inPageLinks() {
      return [{
        title: this.$t('pages.sustainability.text-block-01.title'),
        hash: '#green-energy'
      }, {
        title: this.$t('pages.sustainability.text-block-02.title'),
        hash: '#powering-future'
      }];
    }
  },
  head: {
    title: function title() {
      return {
        inner: this.$t('pages.sustainability.title'),
        complement: this.$t('common.ruyi-group')
      };
    }
  },
  components: {
    InPageNav: __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__["a" /* default */]]
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__ = __webpack_require__(71);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    styles: function styles() {
      return {
        coverBg: {
          backgroundImage: 'url(' + this.assets.cover[this.matchedBreakpoint] + ')'
        }
      };
    },
    assets: function assets() {
      return {
        cover: {
          xs: this.$t('pages.technology.cover.xs'),
          md: this.$t('pages.technology.cover.md'),
          xl: this.$t('pages.technology.cover.xl')
        },
        image01: {
          xs: this.$t('pages.technology.image-block-01.xs'),
          md: this.$t('pages.technology.image-block-01.md'),
          xl: this.$t('pages.technology.image-block-01.xl')
        },
        image02: {
          xs: this.$t('pages.technology.image-block-02.xs'),
          md: this.$t('pages.technology.image-block-02.md'),
          xl: this.$t('pages.technology.image-block-02.xl')
        },
        image03: {
          xs: this.$t('pages.technology.image-block-03.xs'),
          md: this.$t('pages.technology.image-block-03.md'),
          xl: this.$t('pages.technology.image-block-03.xl')
        },
        image04: {
          xs: this.$t('pages.technology.image-block-04.xs'),
          md: this.$t('pages.technology.image-block-04.md'),
          xl: this.$t('pages.technology.image-block-04.xl')
        },
        image05: {
          xs: this.$t('pages.technology.image-block-05.xs'),
          md: this.$t('pages.technology.image-block-05.md'),
          xl: this.$t('pages.technology.image-block-05.xl')
        }
      };
    },
    inPageLinks: function inPageLinks() {
      return [{
        title: this.$t('pages.technology.text-block-01.title'),
        hash: '#research-development'
      }, {
        title: this.$t('pages.technology.text-block-02.title'),
        hash: '#intelligent-manufacturing'
      }, {
        title: this.$t('pages.technology.text-block-03.title'),
        hash: '#global-presence'
      }, {
        title: this.$t('pages.technology.text-block-04.title'),
        hash: '#vertical-integration'
      }];
    }
  },
  head: {
    title: function title() {
      return {
        inner: this.$t('pages.technology.title'),
        complement: this.$t('common.ruyi-group')
      };
    }
  },
  components: {
    InPageNav: __WEBPACK_IMPORTED_MODULE_0__widgets_InPageNav_vue___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_getMatchedBreakpoint__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_updateHead__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_updateInPageNav__["a" /* default */]]
});

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_utils__ = __webpack_require__(72);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    active: {
      type: String
    },
    links: {
      type: Array,
      required: true
    }
  },
  methods: {
    scrollTo: function scrollTo(target) {
      var $target = document.querySelector(target);

      var offset = window.innerHeight / 3;

      if ($target.clientHeight <= window.innerHeight - offset) {
        offset = (window.innerHeight - $target.clientHeight) / 2;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__helpers_utils__["b" /* scrollTo */])($target, -offset);
    }
  }
});

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['showSitemapOverlay', 'showWechatOverlay']))
});

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LandingHeader_LanguageSwitcher__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LandingHeader_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__LandingHeader_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LandingHeader_SideMenuToggler__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LandingHeader_SideMenuToggler___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__LandingHeader_SideMenuToggler__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LandingHeader_SiteNav__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LandingHeader_SiteNav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LandingHeader_SiteNav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StockInfo__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StockInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__StockInfo__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var scrollDelta = 10;

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      threshold: 0,
      lastScrollY: 0,
      isScrolling: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isHidden: function isHidden(state) {
      return state.landingHeader.isHidden;
    },
    isSideMenuOpen: function isSideMenuOpen(state) {
      return state.sideMenu.isOpen;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isHome', 'hasOverlays'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    goBack: function goBack() {
      this.$router.go(-1);
    },
    autoHide: function autoHide(e) {
      var currentScrollY = this.getScrollY();

      if (!this.isSideMenuOpen && !this.hasOverlays) {
        if (this.lastScrollY - currentScrollY > scrollDelta) {
          this.show();
        } else if (currentScrollY - this.lastScrollY > scrollDelta && currentScrollY > this.threshold) {
          this.hide();
        }
      }

      this.lastScrollY = currentScrollY;
      this.isScrolling = false;
    },
    getScrollY: function getScrollY() {
      return window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    },
    updateThreshold: function updateThreshold() {
      this.threshold = this.$el.clientHeight;
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])({
    show: 'showHeader',
    hide: 'hideHeader'
  })),
  mounted: function mounted() {
    var _this = this;

    this.updateThreshold();

    window.addEventListener('scroll', function () {
      if (_this.isScrolling) {
        return;
      }

      _this.isScrolling = true;

      requestAnimationFrame(_this.autoHide);
    }, { passive: true });

    window.addEventListener('resize', function () {
      requestAnimationFrame(_this.updateThreshold);
    }, { passive: true });
  },

  components: {
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_2__LandingHeader_LanguageSwitcher___default.a,
    SideMenuToggler: __WEBPACK_IMPORTED_MODULE_3__LandingHeader_SideMenuToggler___default.a,
    SiteNav: __WEBPACK_IMPORTED_MODULE_4__LandingHeader_SiteNav___default.a,
    StockInfo: __WEBPACK_IMPORTED_MODULE_5__StockInfo___default.a
  }
});

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isContent'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changeLocale: function changeLocale(locale) {
      if (locale === this.$i18n.locale) {
        return;
      }

      if (!this.isContent) {
        return this.setLocale(locale);
      }

      window.location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router__["b" /* localise */])(this.$router.currentRoute, locale);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setLocale']))
});

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['hasOverlays'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toggle: function toggle() {
      this.showHeader();

      if (this.hasOverlays) {
        this.hideOverlays();
      } else {
        this.toggleSideMenu();
      }
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['hideOverlays', 'showHeader', 'toggleSideMenu']))
});

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_velocity_animate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_velocity_animate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isHome'])),
  methods: {
    beforeLinkEnter: function beforeLinkEnter(el) {
      el.style.display = 'none';
      el.style.opacity = 0;
    },
    linkEnter: function linkEnter(el, done) {
      var delay = el.dataset.enter * 150 + 300;
      if (this.isHidden) {
        delay += 1000;
      }

      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_1_velocity_animate___default()(el, {
          opacity: 1,
          translateY: [0, '-100%']
        }, {
          complete: done,
          display: 'block'
        });
      }, delay);
    },
    linkLeave: function linkLeave(el, done) {
      el.style.display = 'none';
      done();
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Overlay__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isShown: function isShown(state) {
      return state.overlays.sitemap.isShown;
    }
  })),
  components: {
    Overlay: __WEBPACK_IMPORTED_MODULE_2__Overlay___default.a
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Overlay__);

//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isShown: function isShown(state) {
      return state.overlays.wechat.isShown;
    }
  })),
  components: {
    Overlay: __WEBPACK_IMPORTED_MODULE_2__Overlay___default.a
  }
});

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SideMenu_FollowUs__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SideMenu_FollowUs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__SideMenu_FollowUs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SideMenu_LanguageSwitcher__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SideMenu_LanguageSwitcher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__SideMenu_LanguageSwitcher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StockInfo__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StockInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StockInfo__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    isOpen: function isOpen(state) {
      return state.sideMenu.isOpen;
    }
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isHome'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])({
    close: 'closeSideMenu'
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['showSitemapOverlay'])),
  components: {
    FollowUs: __WEBPACK_IMPORTED_MODULE_2__SideMenu_FollowUs___default.a,
    LanguageSwitcher: __WEBPACK_IMPORTED_MODULE_3__SideMenu_LanguageSwitcher___default.a,
    StockInfo: __WEBPACK_IMPORTED_MODULE_4__StockInfo___default.a
  }
});

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['showWechatOverlay']))
});

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(35);

//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['isContent'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    changeLocale: function changeLocale(locale) {
      if (locale === this.$i18n.locale) {
        return;
      }

      if (!this.isContent) {
        return this.setLocale(locale);
      }

      window.location = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__router__["b" /* localise */])(this.$router.currentRoute, locale);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapActions */])(['setLocale']))
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapState */])({
    ruyi: function ruyi(state) {
      return state.stocks.ruyi;
    },
    renown: function renown(state) {
      return state.stocks.renown;
    }
  }))
});

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 529 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 530 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 531 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 534 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 535 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 537 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 538 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 541 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 542 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxOSIgaGVpZ2h0PSIzNCI+CiAgICA8cGF0aCBmaWxsPSIjNTU1IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zLjA4MiAxNi44ODJsMTUuMzcxIDE1LjIwNy0xLjQyNiAxLjQxMUwuMjY4IDE2LjkybC4yNzMtLjI3LS4wNDEtLjA0MUwxNy4yODggMGwxLjQyOCAxLjQxM0wzLjA4MiAxNi44ODJ6Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAMAAAC7IEhfAAAAXVBMVEUAAADEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSPEHSOSAE3fAAAAHnRSTlMABUvBdOWFlgp99u+QHxwYFIwP59RoJ+rpsJpD2ciQgnTjAAABEUlEQVQ4y62Uy3LCMAxFSXH8SJz4QQIUWv3/Z3Z8maKVLyw4K3lyxhNFNzo0/IFxflZ5s2vf+5L96YkU4sl2RzX8iMhofM9rTy1eQYBLHa/x3ep0Qz2ZvncccPJmbKc5LswDRYBlHljtRdBRZh4IAlwlHlidNGZDPWCu6N0txAM+CgjMAyngK51CYh6wAuJAPLC4CXfeqAfMDIV6IDvuKfX/zl/uoV9Q3vIw98o9xeWX3qhzp97RmxPmjiTT3A9RgOUekow7x5C4p0mOnno694t54enc3UI8UJ2AwDyQH//71a7c0yQX5oElzqIbrLL8mUmX1HkiOU1OG/L72PWwwXSU943lvsB7sHc9zF1reJ/iD/krL3YFBAwmAAAAAElFTkSuQmCC"

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MCIgaGVpZ2h0PSIyMSI+CiAgICA8cGF0aCBmaWxsPSIjQzIxMzMzIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02MC4wMDMgNC4yMjRsLS4yMzktMS4xODQtMzAuMDc3IDEzLjcyNi4yNCA0LjIyOUw2MC4wMDMgNC4yMjR6IiBvcGFjaXR5PSIuOCIvPgogICAgPHBhdGggZmlsbD0iI0MyMTMzMyIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNLS4wMDMgNC4yMTdsLjIzOS0xLjE4NiAzMC4wNzcgMTMuNzQzLS4yNCA0LjIzTC0uMDAzIDQuMjE3eiIvPgogICAgPHBhdGggZmlsbD0iI0MyMTMzMyIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNDkuODAyLjc4NGwtLjE1OC0uNzgxLTE5Ljg1IDkuMDU5LjE1OCAyLjc5MUw0OS44MDIuNzg0eiIgb3BhY2l0eT0iLjgiLz4KICAgIDxwYXRoIGZpbGw9IiNDMjEzMzMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTEwLjE5OC43NzlsLjE1OC0uNzgzIDE5Ljg1IDkuMDcxLS4xNTggMi43OTJMMTAuMTk4Ljc3OXoiLz4KPC9zdmc+Cg=="

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAACCAYAAABytg0kAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAAVSURBVHjaYvz//z8DCDAxQAFAgAEAMAYDAajvwn8AAAAASUVORK5CYII="

/***/ }),
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(537)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(263),
  /* template */
  __webpack_require__(627),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(540)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(270),
  /* template */
  __webpack_require__(630),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(546)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(271),
  /* template */
  __webpack_require__(637),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(542)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(272),
  /* template */
  __webpack_require__(632),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(273),
  /* template */
  __webpack_require__(636),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(543)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(274),
  /* template */
  __webpack_require__(634),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(536)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(275),
  /* template */
  __webpack_require__(626),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(544)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(276),
  /* template */
  __webpack_require__(635),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(535)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(277),
  /* template */
  __webpack_require__(625),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(531)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(278),
  /* template */
  __webpack_require__(621),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(528)
}
var Component = __webpack_require__(9)(
  /* script */
  __webpack_require__(279),
  /* template */
  __webpack_require__(618),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "fashion-view"
  }, [_c('header', {
    staticClass: "cover fashion-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.subtitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#ruyi-brand-network', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-01",
    attrs: {
      "id": "ruyi-brand-network"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-01.body'))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#ruyi-brand-network', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#smcp', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-02"
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline px-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-04.title'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-01"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image01.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image01.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image01.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-02"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image02.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image02.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image02.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-03",
    attrs: {
      "id": "smcp"
    }
  }, [_c('div', {
    staticClass: "text-block-body"
  }, [_c('h4', {
    staticClass: "brand",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-03.title'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-03.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "font-weight-bold",
    attrs: {
      "href": _vm.$t('pages.fashion.text-block-03.website'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-03.website')) + " "), _c('i', {
    staticClass: "iconfont icon-angle-right iconfont-lg"
  })])])])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#smcp', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#renown', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-04"
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline px-0",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-04.title'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-03"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image03.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image03.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image03.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-04"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image04.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image04.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image04.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-05",
    attrs: {
      "id": "renown"
    }
  }, [_c('div', {
    staticClass: "text-block-body"
  }, [_c('h4', {
    staticClass: "brand",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-05.title'))
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.fashion.text-block-05.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "font-weight-bold",
    attrs: {
      "href": _vm.$t('pages.fashion.text-block-05.website'),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-05.website')) + " "), _c('i', {
    staticClass: "iconfont icon-angle-right iconfont-lg"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-05 d-none d-md-block"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image05.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image05.md))
    }
  }), _vm._v(" "), _c('img')])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#renown', 'up')
      }
    }
  })], 1)]), _vm._v(" "), _c('in-page-nav', {
    attrs: {
      "links": _vm.inPageLinks,
      "active": _vm.inPageNavActive
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-switcher"
  }, [_c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'cn' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('cn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.cn')))]), _vm._v(" "), _c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'en' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.en')))])])
},staticRenderFns: []}

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "technology-view"
  }, [_c('header', {
    staticClass: "cover technology-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.subtitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#research-development', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-01 text-block-rd",
    attrs: {
      "id": "research-development"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.text-block-01.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.technology.text-block-01.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#research-development', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#intelligent-manufacturing', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-01"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image01.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image01.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image01.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-02 text-block-intelligent",
    attrs: {
      "id": "intelligent-manufacturing"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.text-block-02.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.technology.text-block-02.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#intelligent-manufacturing', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#global-presence', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-02"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image02.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image02.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image02.xs))
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "ruyi-logo d-none d-md-block mx-auto",
    attrs: {
      "src": __webpack_require__(600)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-03 text-block-global-presence",
    attrs: {
      "id": "global-presence"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.text-block-03.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.technology.text-block-03.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#global-presence', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#vertical-integration', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-03"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image03.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image03.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image03.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-04 text-block-vertical",
    attrs: {
      "id": "vertical-integration"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.text-block-04.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.technology.text-block-04.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-04"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image04.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image04.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image04.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-05"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image05.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image05.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image05.xs))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#vertical-integration', 'up')
      }
    }
  })], 1)]), _vm._v(" "), _c('in-page-nav', {
    attrs: {
      "links": _vm.inPageLinks,
      "active": _vm.inPageNavActive
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "overlay"
    }
  }, [_c('aside', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "overlay-body"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "follow-us d-none d-xl-block"
  }, [_c('h5', {
    staticClass: "follow-us-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.follow.title')))]), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibo"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wechat"
  })])])
}]}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "sustainability-view"
  }, [_c('header', {
    staticClass: "cover sustainability-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.subtitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#green-energy', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-01",
    attrs: {
      "id": "green-energy"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.sustainability.text-block-01.body'))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#green-energy', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#powering-future', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-01"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image01.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image01.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image01.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-02",
    attrs: {
      "id": "powering-future"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.sustainability.text-block-02.body'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-02"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image02.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image02.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image02.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-03"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image03.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image03.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image03.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-04"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image04.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image04.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image04.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-03"
  }, [_c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.sustainability.text-block-03.body'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-05"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image05.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image05.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image05.xs))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#powering-future', 'up')
      }
    }
  })], 1)]), _vm._v(" "), _c('in-page-nav', {
    attrs: {
      "links": _vm.inPageLinks,
      "active": _vm.inPageNavActive
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "ruyi-view"
  }, [_c('header', {
    staticClass: "cover ruyi-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.subtitle')))])])]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#company-value', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-01 text-block-company-value",
    attrs: {
      "id": "company-value"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.text-block-01.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.ruyi.text-block-01.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-01"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image01.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image01.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image01.xs))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#company-value', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#talents', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-02"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image02.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image02.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image02.xs))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-02 text-block-talent",
    attrs: {
      "id": "talents"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.text-block-02.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.ruyi.text-block-02.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-03"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image03.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image03.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image03.xs))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#talents', 'up')
      }
    }
  })], 1), _vm._v(" "), _c('section', [_c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--top",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#social-responsibility', 'down')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-block text-block-03 text-block-happy-ruyi",
    attrs: {
      "id": "social-responsibility"
    }
  }, [_c('h3', {
    staticClass: "text-block-title text-block-title-underline"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.text-block-03.title')))]), _vm._v(" "), _c('div', {
    staticClass: "text-block-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('pages.ruyi.text-block-03.body'))
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "action-button",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "image-block image-block-04"
  }, [_c('picture', [_c('source', {
    attrs: {
      "media": "(min-width: 1280px)",
      "srcset": ("" + (_vm.assets.image04.xl))
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "srcset": ("" + (_vm.assets.image04.md))
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": ("" + (_vm.assets.image04.xs))
    }
  })])]), _vm._v(" "), _c('v-waypoint', {
    staticClass: "vue-waypoint__waypoint--bottom",
    on: {
      "waypoint-in": function($event) {
        _vm.updateInPageNav('#social-responsibility', 'up')
      }
    }
  })], 1)]), _vm._v(" "), _c('in-page-nav', {
    attrs: {
      "links": _vm.inPageLinks,
      "active": _vm.inPageNavActive
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-view', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "side-menu has-sub-site-nav",
    class: [_vm.isOpen ? 'open' : 'close']
  }, [_c('div', {
    staticClass: "side-menu-brand d-xl-none"
  }, [_c('img', {
    staticClass: "ruyi-logo align-self-center",
    attrs: {
      "src": __webpack_require__(140)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(598)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "side-menu-body"
  }, [_c('ul', {
    staticClass: "site-nav",
    on: {
      "click": _vm.close
    }
  }, [_c('li', {
    staticClass: "d-xl-none"
  }, [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".home")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.home.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))])])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1)])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "site-nav sub-site-nav"
  }, [_c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "site-nav-separator d-none d-xl-block"
  }), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "d-none d-md-block"
  }, [_c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "d-xl-none"
  }, [_c('button', {
    staticClass: "link site-nav-link",
    on: {
      "click": _vm.showSitemapOverlay
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sitemap.title')))])])]), _vm._v(" "), _c('language-switcher', {
    staticClass: "d-md-none"
  }), _vm._v(" "), _c('follow-us', {
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "stock-info"
    }
  }, [(_vm.isHome) ? _c('stock-info', {
    staticClass: "d-xl-none"
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShown) ? _c('overlay', {
    staticClass: "sitemap-overlay"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "sitemap"
  }, [_c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view col-view-ruyi"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__our-philosophy.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__our-philosophy.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__confucian-roots.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__confucian-roots.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__our-staff.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__our-staff.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.company-value__chairman-message.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value__chairman-message.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.talents__recruitment.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents__recruitment.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.talents__talent-development.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents__talent-development.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility__ruyi-cares.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility__ruyi-cares.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility__ruyi-cares.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility__sustainability.title')))])])])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-technology"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.rd__awards-recognitions.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd__awards-recognitions.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.rd__ruyi-technology-research-institute.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd__ruyi-technology-research-institute.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing__eco-textile-spinning-weaving.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing__eco-textile-spinning-weaving.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing__intelligent-equipment.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing__intelligent-equipment.title')))])])])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__textile-in-china.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__textile-in-china.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__milestones.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__milestones.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.global-presence__ruyis_companies.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence__ruyis_companies.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section d-md-none"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-secondary",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration__whole-wool-spinning-industry-chain.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration__whole-wool-spinning-industry-chain.title')))])]), _vm._v(" "), _c('li', {
    staticClass: "col col-subview-section"
  }, [_c('a', {
    staticClass: "sitemap-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration__whole-cotton-spinning-industry-chain.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration__whole-cotton-spinning-industry-chain.title')))])])])])])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-fashion"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section d-md-none"
  })])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view col-view-sustainability"
  }, [_c('router-link', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('ul', {
    staticClass: "row no-gutters"
  }, [_c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view-section"
  }, [_c('router-link', {
    staticClass: "sitemap-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))])], 1)])], 1), _vm._v(" "), _c('li', {
    staticClass: "col col-view"
  }, [_c('a', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))]), _vm._v(" "), _c('a', {
    staticClass: "sitemap-link sitemap-link-primary",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])])])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "landing-layout",
    class: [
      _vm.isHome ? 'is-home' : '',
      _vm.isHeaderHidden ? 'header-hidden' : '',
      _vm.isSideMenuOpen ? 'side-menu-open' : '',
      _vm.hasOverlays ? 'has-overlays' : ''
    ],
    attrs: {
      "id": "landing"
    }
  }, [_c('landing-header'), _vm._v(" "), _c('div', {
    staticClass: "view-wrapper"
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition,
      "mode": "in-out"
    }
  }, [_c('router-view', {
    staticClass: "view"
  }, [_vm._t("default")], 2)], 1)], 1), _vm._v(" "), _c('landing-footer'), _vm._v(" "), _c('side-menu'), _vm._v(" "), _c('sitemap-overlay'), _vm._v(" "), _c('wechat-overlay')], 1)
},staticRenderFns: []}

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "home-view"
  }, [_c('section', {
    staticClass: "cover hero-cover"
  }, [_c('div', {
    staticClass: "cover-bg"
  }), _vm._v(" "), _c('video', {
    staticClass: "hero-video",
    attrs: {
      "autoplay": "",
      "loop": "",
      "playsinline": "",
      "poster": _vm.assets.transparent,
      "preload": "metadata"
    },
    domProps: {
      "muted": _vm.isMobileDevice()
    }
  }, [_c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "src": _vm.$t('pages.home.hero-cover.video.webm.md'),
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "media": "(min-width: 768px)",
      "src": _vm.$t('pages.home.hero-cover.video.mp4.md'),
      "type": "video/mp4"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.$t('pages.home.hero-cover.video.webm.xs'),
      "type": "video/webm"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": _vm.$t('pages.home.hero-cover.video.mp4.xs'),
      "type": "video/mp4"
    }
  })]), _vm._v(" "), _c('img', {
    staticClass: "scroll-down-indicator",
    attrs: {
      "src": __webpack_require__(599)
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "cover ruyi-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.ruyi.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover technology-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.technology.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover fashion-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.fashion.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "cover sustainability-cover"
  }, [_c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.3),
      expression: "0.3"
    }],
    staticClass: "cover-bg",
    style: (_vm.styles.sustainability.coverBg)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "parallax",
      rawName: "v-parallax",
      value: (0.15),
      expression: "0.15"
    }],
    staticClass: "cover-content"
  }, [_c('h1', {
    staticClass: "cover-title"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _vm._v(" "), _c('h2', {
    staticClass: "cover-subtitle"
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.subtitle')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "action-button cover-action-button",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(28)
    }
  })])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "stock-info"
  }, [_c('li', {
    staticClass: "stock renown-stock"
  }, [_c('span', {
    staticClass: "stock-name"
  }, [_vm._v(_vm._s(_vm.$t('common.ruyi-group2')))]), _vm._v(" "), _c('span', {
    staticClass: "stock-performance"
  }, [_vm._v(_vm._s(_vm.ruyi.price) + "¥ (" + _vm._s(_vm.ruyi.change) + "%)")])]), _vm._v(" "), _c('li', {
    staticClass: "stock renown-stock"
  }, [_c('span', {
    staticClass: "stock-name"
  }, [_vm._v("(株)レナウン")]), _vm._v(" "), _c('span', {
    staticClass: "stock-performance"
  }, [_vm._v(_vm._s(_vm.renown.price) + "¥ (" + _vm._s(_vm.renown.change) + "%)")])])])
},staticRenderFns: []}

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "landing-footer"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('nav', {
    staticClass: "site-nav row d-md-flex"
  }, [_c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.company-value.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.company-value.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.talents.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.talents.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.social-responsibility.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.social-responsibility.title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.rd.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.rd.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.intelligent-manufacturing.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.intelligent-manufacturing.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.global-presence.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.global-presence.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link",
    attrs: {
      "href": _vm.$t('links.vertical-integration.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.vertical-integration.title')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#ruyi-brand-network'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.text-block-01.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#smcp'
      }
    }
  }, [_vm._v("SMCP")]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion"),
        hash: '#renown'
      }
    }
  }, [_vm._v("RENOWN")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('router-link', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#green-energy'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-01.title')))]), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability"),
        hash: '#powering-future'
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.text-block-02.title')))]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "site-nav-link site-nav-link-primary",
    on: {
      "click": _vm.showSitemapOverlay
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sitemap.title')))]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))])], 1), _vm._v(" "), _c('a', {
    staticClass: "site-nav-link site-nav-link-primary",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))]), _vm._v(" "), _c('address', {
    staticClass: "ruyi-address d-md-none",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('widgets.footer-address'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "brand mb-md-4 mb-xl-5"
  }, [_c('img', {
    staticClass: "ruyi-logo",
    attrs: {
      "src": __webpack_require__(140)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ruyi-group d-block mx-auto mx-md-0"
  }, [_vm._v(_vm._s(_vm.$t('common.ruyi-group2')))])]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "follow-us"
  }, [_c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-weibo"
  })]), _vm._v(" "), _c('a', {
    staticClass: "follow-us-link",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "iconfont icon-wechat"
  })])])
}]}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "in-page-nav d-none d-md-block"
  }, [_c('ul', _vm._l((_vm.links), function(link) {
    return _c('li', [_c('a', {
      staticClass: "in-page-nav-link",
      class: [link.hash === _vm.active ? 'active' : ''],
      attrs: {
        "href": link.hash
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.scrollTo(link.hash)
        }
      }
    }, [_c('span', {
      staticClass: "in-page-nav-link-title"
    }, [_vm._v(_vm._s(link.title))]), _vm._v(" "), _c('span', {
      staticClass: "in-page-nav-link-dot"
    })])])
  }))])
},staticRenderFns: []}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-switcher"
  }, [_c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'cn' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('cn')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.cn')))]), _vm._v(" "), _c('a', {
    staticClass: "link language-switcher-link",
    class: [_vm.$i18n.locale === 'en' ? 'active' : ''],
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changeLocale('en')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.locale.en')))])])
},staticRenderFns: []}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "site-nav"
  }, [_c('transition-group', {
    staticClass: "d-flex",
    attrs: {
      "tag": "div",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeLinkEnter,
      "enter": _vm.linkEnter,
      "leave": _vm.linkLeave
    }
  }, [(!_vm.isHome) ? _c('router-link', {
    key: "ruyi",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".ruyi")
      },
      "data-enter": "4"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.ruyi.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "technology",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".technology")
      },
      "data-enter": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.technology.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "fashion",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".fashion")
      },
      "data-enter": "2"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.fashion.title')))]) : _vm._e(), _vm._v(" "), (!_vm.isHome) ? _c('router-link', {
    key: "sustainability",
    staticClass: "link site-nav-link",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".sustainability")
      },
      "data-enter": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('pages.sustainability.title')))]) : _vm._e()], 1), _vm._v(" "), _c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.ruyi-news.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.ruyi-news.title')))]), _vm._v(" "), _c('a', {
    staticClass: "link site-nav-link",
    attrs: {
      "href": _vm.$t('links.contact.url')
    }
  }, [_vm._v(_vm._s(_vm.$t('links.contact.title')))])], 1)
},staticRenderFns: []}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('overlay', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShown),
      expression: "isShown"
    }],
    staticClass: "wechat-overlay"
  }, [_c('section', {
    staticClass: "wechat"
  }, [_c('img', {
    staticClass: "wechat-qr-code",
    attrs: {
      "src": __webpack_require__(601)
    }
  }), _vm._v(" "), _c('p', [_vm._v("扫一扫"), _c('br'), _vm._v("关注如意官方微信")])])])
},staticRenderFns: []}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "side-menu-toggler",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggle($event)
      }
    }
  }, [_c('div', {
    staticClass: "side-menu-toggler-icon mx-auto",
    class: [_vm.hasOverlays ? 'side-menu-toggler-icon-cross' : '']
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])])
},staticRenderFns: []}

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "landing-header",
    class: [_vm.isHidden ? 'hidden' : '']
  }, [_c('div', {
    staticClass: "header-left"
  }, [_c('side-menu-toggler')], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body"
  }, [_c('transition', {
    attrs: {
      "name": "stock-info"
    }
  }, [(_vm.isHome) ? _c('stock-info', {
    staticClass: "d-none d-xl-block"
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "header-body-container"
  }, [_c('router-link', {
    staticClass: "ruyi-logo align-self-center",
    attrs: {
      "to": {
        name: ((_vm.$i18n.locale) + ".home")
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(140)
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "go-back-button"
    }
  }, [(!_vm.isHome) ? _c('button', {
    staticClass: "go-back-button d-none d-xl-block",
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(597)
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "links d-none d-md-flex justify-content-end"
  }, [_c('site-nav'), _vm._v(" "), _c('language-switcher')], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cn/common.json": 644,
	"./cn/links.json": 645,
	"./en/common.json": 646,
	"./en/links.json": 647
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = {"ruyi-group":"如意集团","ruyi-group2":"如 意 集 团","locale":{"cn":"中文","en":"EN"}}

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = {"company-value":{"title":"@:pages.ruyi.text-block-01.title","url":"/content/company-value"},"company-value__our-philosophy":{"title":"我们的理念","url":"/content/company-value#subsection_3_1"},"company-value__confucian-roots":{"title":"我们的源泉","url":"/content/company-value#subsection_3_2"},"company-value__our-staff":{"title":"我们的员工","url":"/content/company-value#section_7"},"company-value__chairman-message":{"title":"董事长宣言","url":"/content/company-value#section_9"},"talents":{"title":"@:pages.ruyi.text-block-02.title","url":"/content/talents"},"talents__recruitment":{"title":"广纳贤才","url":"/content/talents#subsection_3_1"},"talents__talent-development":{"title":"人才发展","url":"/content/talents#subsection_10_1"},"social-responsibility":{"title":"温暖使命","url":"/content/social-responsibility"},"social-responsibility__ruyi-cares":{"title":"@:pages.ruyi.text-block-03.title","url":"/content/social-responsibility#section_3"},"social-responsibility__sustainability":{"title":"幸福永相随","url":"/content/social-responsibility#subsection_15_1"},"rd":{"title":"@:pages.technology.text-block-01.title","url":"/content/rd"},"rd__awards-recognitions":{"title":"荣誉奖项","url":"/content/rd#section_3"},"rd__ruyi-technology-research-institute":{"title":"技术研究院","url":"/content/rd#subsection_10_1"},"intelligent-manufacturing":{"title":"@:pages.technology.text-block-02.title","url":"/content/intelligent-manufacturing"},"intelligent-manufacturing__eco-textile-spinning-weaving":{"title":"生态纺织","url":"/content/intelligent-manufacturing#section_3"},"intelligent-manufacturing__intelligent-equipment":{"title":"智能设备","url":"/content/intelligent-manufacturing#section_8"},"global-presence":{"title":"@:pages.technology.text-block-03.title","url":"/content/global-presence"},"global-presence__textile-in-china":{"title":"纺织在中国","url":"/content/global-presence#section_3"},"global-presence__milestones":{"title":"扩展里程碑","url":"/content/global-presence#subsection_9_1"},"global-presence__ruyis_companies":{"title":"如意旗下公司","url":"/content/global-presence#subsection_13_1"},"vertical-integration":{"title":"@:pages.technology.text-block-04.title","url":"/content/vertical-integration"},"vertical-integration__whole-wool-spinning-industry-chain":{"title":"毛纺全产业链","url":"/content/vertical-integration#section_3"},"vertical-integration__whole-cotton-spinning-industry-chain":{"title":"棉纺全产业链","url":"/content/vertical-integration#subsection_10_1"},"ruyi-news":{"title":"@:pages.news.title","url":"/content/category/ruyi-news"},"contact":{"title":"@:pages.contact.title","url":"/content/contact"}}

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = {"ruyi-group":"Ruyi Group","ruyi-group2":"Ruyi Group","locale":{"cn":"中文","en":"EN"}}

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = {"company-value":{"title":"@:pages.ruyi.text-block-01.title","url":"/content/en/company-value"},"company-value__our-philosophy":{"title":"Our Philosophy","url":"/content/en/company-value#subsection_3_1"},"company-value__confucian-roots":{"title":"Confucion Roots","url":"/content/en/company-value#subsection_3_2"},"company-value__our-staff":{"title":"Our Staff","url":"/content/en/company-value#section_7"},"company-value__chairman-message":{"title":"Chairman's Message","url":"/content/en/company-value#section_9"},"talents":{"title":"@:pages.ruyi.text-block-02.title","url":"/content/en/talents"},"talents__recruitment":{"title":"Recruitment","url":"/content/en/talents#subsection_3_1"},"talents__talent-development":{"title":"Talent Development","url":"/content/en/talents#subsection_10_1"},"social-responsibility":{"title":"@:pages.ruyi.text-block-03.title","url":"/content/en/social-responsibility"},"social-responsibility__ruyi-cares":{"title":"Ruyi Cares","url":"/content/en/social-responsibility#section_3"},"social-responsibility__sustainability":{"title":"Sustainability","url":"/content/en/social-responsibility#subsection_15_1"},"rd":{"title":"@:pages.technology.text-block-01.title","url":"/content/en/rd"},"rd__awards-recognitions":{"title":"Awards & Recognitions","url":"/content/en/rd#section_3"},"rd__ruyi-technology-research-institute":{"title":"Ruyi Technology Research Institute","url":"/content/en/rd#subsection_10_1"},"intelligent-manufacturing":{"title":"@:pages.technology.text-block-02.title","url":"/content/en/intelligent-manufacturing"},"intelligent-manufacturing__eco-textile-spinning-weaving":{"title":"Eco-textile Spinning & Weaving","url":"/content/en/intelligent-manufacturing#section_3"},"intelligent-manufacturing__intelligent-equipment":{"title":"Intelligent Equipment","url":"/content/en/intelligent-manufacturing#section_8"},"global-presence":{"title":"@:pages.technology.text-block-03.title","url":"/content/en/global-presence"},"global-presence__textile-in-china":{"title":"Textile in China","url":"/content/en/global-presence#section_3"},"global-presence__milestones":{"title":"Milestones","url":"/content/en/global-presence#subsection_9_1"},"global-presence__ruyis_companies":{"title":"Ruyi's Companies","url":"/content/en/global-presence#subsection_13_1"},"vertical-integration":{"title":"@:pages.technology.text-block-04.title","url":"/content/en/vertical-integration"},"vertical-integration__whole-wool-spinning-industry-chain":{"title":"Whole Wool Spinning Industry Chain","url":"/content/en/vertical-integration#section_3"},"vertical-integration__whole-cotton-spinning-industry-chain":{"title":"Whole Cotton Spinning Industry Chain","url":"/content/en/vertical-integration#subsection_10_1"},"ruyi-news":{"title":"@:pages.news.title","url":"/content/en/category/ruyi-news"},"contact":{"title":"@:pages.contact.title","url":"/content/en/contact"}}

/***/ })
]),[239]);


// WEBPACK FOOTER //
// static/js/app.js